import * as Sentry from '@sentry/react';

const enableSentry =
  process.env.NODE_ENV === 'production' && process.env.NODE_CONFIG_ENV === 'production';

function hackSentryFetch() {
  // A hack for sentry
  // Sandbox of Qiankun overrides the original fetch
  // Need to create a private fetch and override its toString function
  // eslint-disable-next-line @typescript-eslint/no-implied-eval
  const nativeFetch = new Function('return this.fetch')();
  const privateFetch: typeof fetch = function (...p) {
    return nativeFetch(...p);
  };

  privateFetch.toString = () => 'function fetch() { [native code] }';
  window.fetch = privateFetch;
}

export function start() {
  if (enableSentry) {
    hackSentryFetch();
    Sentry.init({
      dsn: 'https://f68f63530b836be4b9d6ce3697232f9d@o123592.ingest.us.sentry.io/4508324293378048',
      environment: process.env.NODE_CONFIG_ENV,
      integrations: [Sentry.browserTracingIntegration()],
      ignoreErrors: [/ResizeObserver loop/],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.7,
    });
  }
}

export function stop() {
  if (enableSentry) {
    Sentry.init({ dsn: '' });
  }
}
